import React, { useState } from 'react';
import { ForgotUsernameForOLB, SendFactorForForgotUsername, VerifyPasscodeForForgotUsername } from 'api';
import { ForgotUsernameForm, FactorSelectionForm, VerifyPasscodeForm } from 'forms';
import { Process, Success } from 'common';
import { useApi } from 'hooks';

const ForgotUsernamePage = () => {
  const [step, setStep] = useState(1);
  const [member, setMember] = useState();
  const [factors, setFactors] = useState();
  const [selectedFactor, setSelectedFactor] = useState();

  const [forgotStatus, callForgotUsername] = useApi(ForgotUsernameForOLB);
  const [sendStatus, callSendFactor] = useApi(SendFactorForForgotUsername);
  const [verifyStatus, callVerifyPasscode] = useApi(VerifyPasscodeForForgotUsername);

  const forgotUsername = (accountNumber, ssn) => {
    callForgotUsername(accountNumber, ssn).then((data) => {
      if (data) {
        setMember({ accountNumber, ssn });
        setFactors(data);
        setStep(2);
      }
    });
  };

  const send = (factor) => {
    setSelectedFactor(factor);
    callSendFactor(member, factor).then((data) => {
      if (data) setStep(3);
    });
  };

  const verify = async (passcode) => {
    await callVerifyPasscode(member, selectedFactor, passcode);
    setStep(4);
  };

  const isLoading = () => forgotStatus.isLoading || sendStatus.isLoading || verifyStatus.isLoading;

  const error = () => {
    let tempError = false;
    if (forgotStatus.error) tempError = forgotStatus.error;
    if (sendStatus.error) tempError = sendStatus.error;
    if (verifyStatus.error) tempError = verifyStatus.error;
    return tempError;
  };

  return (
    <Process error={error} isLoading={isLoading}>
      {step === 1 && <ForgotUsernameForm forgot={forgotUsername} />}
      {step === 2 && <FactorSelectionForm factors={factors} send={send} />}
      {step === 3 && (
        <VerifyPasscodeForm verify={verify} selectedFactor={selectedFactor} resend={() => send(selectedFactor)} />
      )}
      {step === 4 && (
        <Success header={'Your Username has been sent to your email address on file.'} href={'/sign-in'} />
      )}
    </Process>
  );
};

export default ForgotUsernamePage;
